import type { Group, Pouch, Sheet } from '../../types';
import { syncSheetPouchesToActiveLayer } from '../../logic/LayerLogic';
import { HistoryLogic } from '../../utils/HistoryLogic';

export type HistoryNavigationDirection = 'undo' | 'redo';

export function applyHistoryNavigation(
  sheet: Sheet,
  direction: HistoryNavigationDirection,
): { sheet: Sheet; pouches: Pouch[]; groups: Group[] } | null {
  const result =
    direction === 'undo'
      ? HistoryLogic.undo(sheet)
      : HistoryLogic.redo(sheet);
  if (!result) return null;

  let nextSheet = result.newSheet;
  let pouches = result.newPouches;
  let groups = result.newGroups;

  if (nextSheet.layers?.length) {
    const synced = syncSheetPouchesToActiveLayer({
      ...nextSheet,
      pouches,
      groups,
    });
    nextSheet = synced;
    pouches = synced.pouches;
    groups = synced.groups;
  }

  return { sheet: nextSheet, pouches, groups };
}
